export default {
  app: {
    name: 'MedIM'
  },
  init: {
    loading: 'Initializing...',
    connecting: 'Connecting...',
    loginIM: 'Logging into messaging...',
    subtitle: 'Instant Messaging',
    footer: 'Secure encrypted messaging service',
    error: {
      noToken: 'The link is invalid, please get it again.',
      sigFail: 'Failed to get signature, please retry',
      loginFail: 'Login failed: {msg}',
      retry: 'Retry',
      hint: 'Please check your network connection and retry'
    }
  },
  permission: {
    title: 'Permissions Not Enabled',
    desc: 'To ensure normal calls, please tap the button below and select "Allow" when your browser shows the permission prompt',
    openBtn: 'Enable Access',
    skipBtn: 'Skip for Now',
    deniedTitle: 'Please Enable Microphone/Camera Access',
    deniedDesc: 'Please enable in browser settings, then tap the button below to retry',
    deniedStep1: 'Method 1 (recommended): Click the lock icon 🔒 in the browser address bar',
    deniedStep2: '→ Permissions → Microphone/Camera → Set to "Allow"',
    deniedStep3: 'Method 2: Open browser Settings → Privacy & Security → find and allow microphone/camera',
    deniedBtn: 'Retry'
  },
  agreement: {
    title: 'User Agreement',
    loading: 'Loading agreement...',
    loadFail: 'Failed to load agreement, please retry',
    retry: 'Retry',
    agree: 'I Agree',
    reject: 'I Disagree',
    scrollHint: 'Please read the full agreement to continue',
    rejectedTitle: 'You declined the agreement',
    rejectedDesc: 'Please close this page'
  },
  conversation: {
    title: 'Messages',
    empty: 'No conversations',
    online: 'Online',
    offline: 'Offline',
    connecting: 'Connecting',
    user: 'User',
    lastMsg: {
      image: '[Image]',
      audio: '[Voice]',
      video: '[Video]',
      file: '[File]',
      face: '[Emoji]',
      custom: '[Message]',
      calling: '[Call]',
      recall: 'Message recalled'
    }
  },
  chat: {
    placeholder: 'Say something...',
    send: 'Send',
    recall: 'Recall',
    recallSuccess: 'Message recalled',
    recallFail: 'Recall failed, time limit exceeded',
    copyText: 'Copy',
    deleteMsg: 'Delete',
    loadMore: 'Load more',
    noMore: 'No more messages',
    inputPlaceholder: 'Type a message...',
    calling: '[Video call]',
    callEnd: 'Call ended',
    callDuration: 'Duration {duration}',
    callConnected: 'Call connected',
    callMissed: 'Missed',
    callCancelled: 'Hang upped',
    callRejected: 'Declined',
    imagePreview: 'Preview',
    downloadFile: 'Download',
    voiceSeconds: '{sec}s',
    customLink: 'View details',
    survey: 'Rating',
    holdToSpeak: 'Hold to speak',
    releaseToSend: 'Release to send',
    releaseToCancel: 'Slide up to cancel',
    durationSecond: '{count}s'
  },
  call: {
    incomingVideo: 'Video Call',
    incomingAudio: 'Voice Call',
    calling: 'Calling...',
    callingUser: 'Calling {name}...',
    incomingFrom: '{name} is calling',
    incomingVideoFrom: '{name} is video calling',
    incomingAudioFrom: '{name} is voice calling',
    connecting: 'Connecting...',
    accept: 'Accept',
    reject: 'Decline',
    hangup: 'Hang up',
    mute: 'Mute',
    unmute: 'Unmute',
    camera: 'Camera',
    switchCamera: 'Flip',
    speaker: 'Speaker',
    timeout: 'No answer',
    busy: 'Line busy',
    callRejected: 'Call declined',
    ended: 'Call ended',
    duration: 'Duration {duration}',
    failed: 'Call failed',
    permissionDenied: 'Please allow camera and microphone',
    networkError: 'Unstable network',
    videoCall: '[Video Call]',
    audioCall: '[Voice Call]'
  },
  common: {
    confirm: 'Confirm',
    cancel: 'Cancel',
    back: 'Back',
    loading: 'Loading...',
    networkError: 'Network error, please check connection',
    unknownError: 'An unknown error occurred',
    today: 'Today',
    yesterday: 'Yesterday'
  },
  error: {
    expired: 'Link expired',
    kicked: 'Logged in on another device',
    noauth: 'Please enter from the correct link',
    somethingWrong: 'Something went wrong',
    expiredDesc: 'Please get a new access link',
    kickedDesc: 'Your account is logged in on another device, current session disconnected',
    noauthDesc: 'Missing required token in URL, please scan QR code or get a new link'
  },
  message: {
    unknownFile: 'Unknown file',
    unsupportedMsg: '[Unsupported message type]',
    viewDetail: 'View details',
    sessionCreated: 'Session created',
    systemMsg: '[System message]',
    sendFailed: 'Send failed, please retry',
    imageSendFailed: 'Image send failed, please retry',
    roomInvalid: 'Invalid room info'
  }
}
